<script>
	import {onMount} from 'svelte'
	import {scale} from 'svelte/transition'
	import {syllable} from 'syllable' //https://www.npmjs.com/package/syllable

	import Audio from './audio.svelte'
	import Icon from './icon.svelte'

	//https://www.datamuse.com/api/

	let p, area, filehandle;
	const file_picker_opts = {
		types: [
			{
				description:"json",
				accept:{"application/json": ['.json']}
			}
		],
		excludeAllOption:true,
		multiple:false
	}
	const opts = {
		max_fetech:25, 
		debug:false, 
		replace:false, 
		do_fetch:true
	}
	const selected = {
		word:'',
		index:-1,
		found:[{word:'bar', score:42}, {word:'car', score:69}]
	}
	let data = {
		title:'Untitled',
		text:'',
		tokens:[],
		syllables:[]
	}

	// $:console.log({...data})

	const resizeObserver = new ResizeObserver((entries) => {
		for (const entry of entries) {
			const pad = parseInt(getComputedStyle(entry.target).padding.split('px')[0])
			const width = entry.target.offsetWidth - (pad * 2)
			const height = entry.target.offsetHeight - (pad * 2)
			// console.log(pad, width, height)
			p.style = `width: ${width}px; height: ${height}px;`
		}
	});

	if (!String.prototype.splice) {
		/**
		 * {JSDoc}
		 *
		 * The splice() method changes the content of a string by removing a range of
		 * characters and/or adding new characters.
		 *
		 * @this {String}
		 * @param {number} start Index at which to start changing the string.
		 * @param {number} delCount An integer indicating the number of old chars to remove.
		 * @param {string} newSubStr The String that is spliced in.
		 * @return {string} A new string with the spliced substring.
		 */
		String.prototype.splice = function(start, delCount, newSubStr) {
			return this.slice(0, start) + newSubStr + this.slice(start + Math.abs(delCount));
		};
	}

	onMount(async () => {
		resizeObserver.observe(area);
	})

	function Split(){
		data.tokens = data.text.split(/\b/gmi) //[\n\s\r\t]
		data.syllables = data.text.split(/\n/gmi).map(sentence => syllable(sentence))
	}
	Split()

	function Search(word, index){
		if(!word)return;
		selected.word = word
		selected.index = index
	}

	function SelectSuggested(word){
		if(replace){
			data.tokens[selected.index] = word
			data.text = data.tokens.join('')
		}
		else{
			data.text = data.text.splice(area.selectionStart, 0, word)
			Split()
		}
	}

	async function LoadDoc(){
		[filehandle] = await window.showOpenFilePicker(file_picker_opts)
		const file = await filehandle.getFile()
		data = JSON.parse(await file.text())
	}

	async function SaveDoc(){
		const stream = await filehandle.createWritable()
		await stream.write(JSON.stringify(data))
		await stream.close()
	}

	async function SaveAsDoc(){
		filehandle = await window.showSaveFilePicker(file_picker_opts)
		SaveDoc()
	}
</script>

<main>
	<section class="doc" class:debug={opts.debug}>
		<div class="title">
			<input type="text" bind:value={data.title}>
			<button on:click={LoadDoc} title="Load a document"><Icon>plagiarism</Icon></button>
			<button on:click={SaveDoc} title="Save current document file"><Icon>save</Icon></button>
			<button on:click={SaveAsDoc} title="Download current document"><Icon>file_download</Icon></button>
		</div>
		<div class="write" class:debug={opts.debug}>
			<textarea on:input={(e) => {data.text = e.target.value; Split()}} value={data.text} class:debug={opts.debug} autofocus spellcheck="false" TextMode="MultiLine" bind:this={area}></textarea>
			<p bind:this={p} class:debug={opts.debug}>
				{#each data.tokens as t, i (i)}
					<span on:click={() => Search(t, i)} class:debug={opts.debug} class="{selected.index == i ? 'selected' : ''} {t.match(/[\s\n\r\t]+/gmi) ? 'disabled':''}">{t}</span>
				{/each}
			</p>
			<div class="syllables">
				{#each data.syllables as s}
					<h2>{s}</h2>
				{/each}
			</div>
		</div>
	</section>

	<div class="vert">
		<h1 class="app_name">Lirify <h2>- a song lyrics writing web app tool made in Latvia by <a href="http://rolandslaucis.lv" target="_blank">Rolands Laucis</a> with love for Svelte and good design.</h2></h1>

		<div>
			<Audio></Audio>
		</div>

		<section class="opts">
			<label title="Debug view of the site">Debug<input type="checkbox" bind:checked={opts.debug}></label>
			<label title="Request rhymes from the server?">Fetch<input type="checkbox" bind:checked={opts.do_fetch}></label>
			<label title="How many words to fetch">Max fetch<input type="number" min="1" max="100" bind:value={opts.max_fetech}></label>
			<label title="Replace the selected word?">Replace<input type="checkbox" bind:checked={opts.replace}></label>
		</section>

		<section class="search">
			<h2>Word | Syllables | Score <span style="font-size: 12px;">(click to {opts.replace ? 'replace selected' : 'add at cursor'})</span></h2>

			<div class="words">
				{#await opts.do_fetch ? fetch(`https://api.datamuse.com/words?rel_rhy=${selected.word}&max=${opts.max_fetech}`).then(res => res.json()) : selected.found}
					<h3>loading...</h3>
				{:then found} 
					{#if Object.keys(found).length > 0}
						{#each found as f (f.word)}
							<h3 transition:scale on:click={() => SelectSuggested(f.word)}>
								<b>{f.word}</b> | {syllable(f.word)} | {f.score}
							</h3>
						{/each}
					{:else}
						<h3>No rhymes with "{selected.word}" found 😔</h3>
					{/if}
				{:catch e}
					{e}
				{/await}
			</div>
		</section>
	</div>
</main>

<style lang="scss">
	$pad: 32px;
	$text_pad:48px;
	$main_size: calc(100% - #{$pad * 2});
	$text_area_size: calc(100% - #{$text_pad * 2} - 5px);

	main{
		width: $main_size;
		height: $main_size;
		padding: $pad;
		background-color: $dark;
		position: relative;
		display: flex;
		gap: 24px;
		overflow-y: auto;

		.vert{
			width: 50%;
			height: 100%;
			display: flex;
			flex-direction: column;
			gap: 24px;
		}
	}

	textarea, p, h1, h3, h2, input, label{
		@include text;
		@include no_spacings;
		caret-color: $light;
	}

	.app_name{
		grid-area: name;
		font-size: 48px;
		font-weight: bold;
		color: $light;

		display: flex;
		align-items: baseline;
		gap: 32px;

		h2{
			font-weight: 200;
			font-size: 14px;

			a{
				color: $accent;
				transition: $trans;

				&:hover{
					color: $accent_hover;
				}
			}
			
		}
	}

	.opts{
		grid-area: opts;
		display: flex;
		flex-wrap: wrap;
		gap: 12px;

		label{
			background-color: $gray1;
			padding: 6px 12px;
			border-radius: 8px;

			display: flex;
			align-items: center;
			gap: 6px;

			input[type=checkbox]{
				width: 24px;
				aspect-ratio: 1 / 1;
				&:hover{
					cursor: pointer;
				}
			}

			&:hover{
				background-color: $gray2;
				cursor: pointer;
			}
		}
	}

	input[type=text]{
		grid-area: title;
		border: none;
		outline: none;
		font-size: 24px;
		font-weight: bold;
		padding: 8px;
		border-bottom: 1px solid $gray1;

		background: transparent;
		width: calc(100% - 16px);
		transition: $trans;

		&:hover{
			border-bottom: 1px solid $accent;
		}
		&:focus{
			border-bottom: 1px solid $accent_hover;
		}
	}

	.doc{
		width: 50%;
		flex-grow: 1;
		height: 100%;
		display: flex;
		flex-direction: column;
		gap: 24px;

		&.debug{outline: 1px dashed purple;}
	}
	@media only screen and (max-width: 800px) {
		main {
			$pad:16px;
			flex-direction: column;
		}
		.doc, main .vert{width: 100%; min-height: 800px;}
		main .vert{flex-direction: column-reverse;}
	}

	.title{
		display: flex;
		align-items: center;
		gap: 6px;

		input{
			flex-grow: 1;
		}

		button{
			@include button;
		}
	}
	.write{
		width: 100%;
		height: 100%;
		position: relative;
		overflow-y: auto;
		overflow-x: hidden;

		&.debug{outline: 1px dashed blue;}
	}
	textarea, p{
		width: $text_area_size;
		height: $text_area_size;
		max-width: $text_area_size;
		overflow: hidden;
	}
	textarea{
		padding: $text_pad;
		outline: 1px solid $gray1;
		color: $dark;
		text-decoration: none;
		resize: both;
		background-color: $dark;

		&.debug{color: $dark;}

		&::selection {
			background: $accent;
			color: transparent;
		}
	}
	p{
		white-space: pre;
		word-wrap: break-word;

		position: absolute;
		z-index: 99;
		left: $text_pad;
		top: $text_pad;
		pointer-events: none;

		&.debug{outline: 1px dashed red;}

		span{
			pointer-events: all;
			transition: $trans;
			border-radius: 4px;

			&.debug{outline: 1px dashed green;}
			&.selected{color: $accent;}
			&.disabled{pointer-events: none;}

			&:hover{
				background-color: $gray2; 
				cursor: pointer;
			}
			&.disabled:hover{
				cursor: text;
			}
		}
	}

	.search{
		grid-area: words;
		width: 100%;
		height: 100%;
		border-left: 1px solid $gray1;
		padding-left: 12px;
		display: flex;
		flex-direction: column;
		justify-content: left;
		gap: 24px;

		.words{
			display: flex;
			flex-wrap: wrap;
			justify-content: left;
			gap: 12px;

			h3{
				height: min-content;
				background-color: $gray1;
				padding: 6px 12px;
				border-radius: 8px;

				transition: $trans;

				&:hover{
					cursor: pointer;
					background-color: $gray2;
					color: $accent;
				}
			}
		}
	}

	.syllables{
		grid-area: write;
		position: absolute;
		z-index: 99;
		left: $text_pad / 3;
		top: $text_pad;
		pointer-events: none;

		display: flex;
		flex-direction: column;
		
		h2{
			font-weight: bold;
			color: $accent;
		}
	}
</style>